import {useState, useEffect, useRef} from 'react';

import '../../modules/workflow/Workflow.scss';
import {useParams} from "react-router-dom";
import {UseRequest} from "../../hooks/UseRequest";
import {Enums} from "../../config/Config";


import Select from "../../modules/form/Select";
import {FiArchive, FiInbox, FiSend, FiShoppingBag, FiTrash} from "react-icons/fi";
import {AiFillFolderOpen} from "react-icons/ai";
import {TbFaceIdError, TbHandClick, TbRefreshAlert} from "react-icons/tb";
import {AlertTriangle} from "react-feather";
import Item from "../../modules/stats/Item";
import UseGetFormData from "../../hooks/UseGetFormData";
import {UtcDateTimeToDateTime} from "../../hooks/dates";

import Preloader from "../../components/preloader";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";
import {UseDownload, UsePut} from "../../hooks/http";
import ListingTable from "../../components/listing/listing";



const Statistics = (props) => {
    const {id} = useParams()
    const FormRef = useRef()
    const [kpis, setKpis] = useState(null)
    const [kpisFilters, setKpisFilters] = useState({id_journey: id})

    const [lastChanged, setLastChanged] = useState(new Date())
    const [listingFilters, setListingFilters] = useState({limit: 30, offset: 0, id_journey: id})


    const [channel, setChannel] = useState(null)
    const [creativity, setCreativity] = useState(null)
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [creativities, setCreativities] = useState([])


    const searchColumn = 'name'
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())


    const fetchStatistics = async (params) => {
        return await (await UseRequest(
            `${process.env.REACT_APP_BASE_API}/journeys/statistics/get`,
            {request: {method: 'PUT', data: params}}
        )).json()
    }


    const fetchCreativities = async (channel) => {
        return await (await UseRequest(
            `${process.env.REACT_APP_BASE_API}/journeys/creativities/get`,
            {request: {method: 'PUT', data: {offset: 0, id_journey: id, slug_channel: channel}}}
        )).json()
    }


    useEffect(() => {
        fetchStatistics(kpisFilters)
            .then((response) => {
                setKpis(response.kpis)

                UsePut('/journeys/statistics/get',
                    {data: listingFilters}
                ).then((response) => {
                    setEntities(response?.entities)
                    setIsLoading(false)
                })

            })
    }, [kpisFilters, listingFilters, currentOffset, currentLimit, searchValue, currentOrder, lastChange])


    const handleChannel = async (selected) => {
        const values = [];
        setChannel(selected)


        if (selected && selected.value) {
            const data = await fetchCreativities(selected.value)
            data && data.forEach((creativity) => {
                values.push({
                    value: creativity.id_entity.value,
                    label: `${creativity.id_entity.label}`,
                })
            })
        }
        setCreativities(values)
    }


    const handleFilterSubmit = (ev) => {
        ev.preventDefault();
        const formData = UseGetFormData(FormRef)
        let params = {id_journey: id};

        if (formData.get('channel') !== '') {
            params['channel'] = formData.get('channel')
        }

        if (formData.get('id_creativity') !== '') {
            params['id_creativity'] = formData.get('id_creativity')
        }

        if (formData.get('start_date') !== '') {
            params['start_date'] = formData.get('start_date')
        }

        if (formData.get('end_date') !== '') {
            params['end_date'] = formData.get('end_date')
        }

        /*let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        const request = await UsePut("/journeys/statistics/get",
            {data: filters}
        );

        setTotalEntities(request.total);
        return request?.entities?.length > 0 ?
            request.entities : [];*/


        setKpisFilters(params)
        setListingFilters(params)
        setLastChanged(Date.now())
    }


    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        card          : false,
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            setKpisFilters(prevState => ({
                ...prevState,
                limit: parseInt(ev.target.text)
            }))
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            setKpisFilters(prevState => ({
                ...prevState,
                sortBy   : "created_at",
                sortOrder: ev.target.text
            }))
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "First Name", prop: "first_name", output: (entity) => {
                    return entity?.Entity?.first_name
                }
            },
            {
                label: "Last Name", prop: "last_name", output: (entity) => {
                    return entity?.Entity?.last_name
                }
            },
            {
                label: "Phone number", prop: "phone_number", output: (entity) => {
                    return entity?.Entity?.phone_number
                }
            },
            {
                label: "Mobile phone", prop: "mobile_phone", output: (entity) => {
                    return entity?.Entity?.mobile_phone
                }
            },
            {
                label: "Mobile provider", prop: "mobile_provider", output: (entity) => {
                    return entity?.Entity?.mobile_provider
                }
            },
            {
                label: "Email address", prop: "email_address", output: (entity) => {
                    return entity?.Entity?.email_address
                }
            },
            {
                label: "Channel", prop: "channel", size: 25
            },
            {
                label: "Creativity", prop: "creativity", output: (entity) => {
                    return entity?.channel === "email" ? entity?.Email?.content?.subject : entity?.Sms?.title
                }
            },
            {
                label: "Status", prop: "status", output: (entity) => {
                    return entity?.status ? entity.status : 'Sent'
                }
            },
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            }
        ],
        filters       : [],
        actions       : [
            {value: "download_selected", label: "Download", action: (selected) => downloadSelected(selected)},
            {value: "download_all", label: "Download All", action: () => downloadAll()}
        ],
        edit          : {
            path : `/journeys/:id`,
            label: "Edit journey",
            icon : "edit"
        }
    };


    const handleStatusClick = (status) => {
        const newStatus = {...listingFilters, ...{status: status}}
        if (status === null) {
            delete newStatus['status']
        }

        setListingFilters(newStatus)
        setLastChanged(new Date())
    }


    const downloadSelected = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            const params = {
                ...kpisFilters,
                download: true,
                selected: selected
            }

            UseDownload(
                '/journeys/statistics/get', {data: params}
            ).then((response) => {

            })
        }
    };


    const downloadAll = async () => {
        const params = {
            ...kpisFilters,
            download: true,
            selected: 'all'
        }

        UseDownload(
            '/journeys/statistics/get', {data: params}
        ).then((response) => {

        })
    }


    return (
        <div className="Journey statistics">
            <div className="card">
                <Preloader maskOnly isReady={!isLoading}/>
                {!isLoading && <>
                    <div className="statistics-filter">
                        <form ref={FormRef} onSubmit={handleFilterSubmit}>
                            <ul className="list-inline list-unstyled">
                                <li className="list-inline-item">
                                    <Select
                                        name='channel'
                                        value={channel}
                                        placeholder='Channel'
                                        options={Enums.channels}
                                        onChange={handleChannel}
                                        className="min-width-160"
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Select
                                        name='id_creativity'
                                        placeholder='Creativity'
                                        options={creativities}
                                        value={creativity}
                                        className={`options-md ${creativities && creativities.length > 0 && 'has-options'}`}
                                        onChange={(ev) => {
                                            setCreativity(ev)
                                        }}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <input
                                        name="start_date"
                                        value={startDate}
                                        type='datetime-local'
                                        className='form-control input-sm'
                                        onChange={(ev) => {
                                            setStartDate(ev.target.value)
                                        }}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <input
                                        name="end_date"
                                        value={endDate}
                                        type='datetime-local'
                                        className='form-control input-sm'
                                        onChange={(ev) => {
                                            setEndDate(ev.target.value)
                                        }}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <button type="submit" className="btn btn-primary btn-input-sm">Apply</button>
                                </li>
                            </ul>
                        </form>
                    </div>
                    <div className="statistics-resume">
                        {channel?.value !== 'webservice' && <>
                            <ul className="list-inline list-unstyled">
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick(null)}
                                        label="Sent"
                                        icon={<FiSend/>}
                                        background={'#bdc2c4'}
                                        styles={{marginRight: '-10px'}}
                                        items={kpis ? kpis.Send : 0}
                                        percent={kpis.Send == 0 ? 0 : 100}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Delivery')}
                                        icon={<FiInbox/>}
                                        background={'#90d4b6'}
                                        label="Delivered"
                                        items={kpis.Delivery ? kpis.Delivery : 0}
                                        percent={Math.floor(kpis.Delivery ? kpis.Send === 0 ? 0 : kpis.Delivery * 100 / kpis.Send : 0)}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Undelivery')}
                                        icon={<TbFaceIdError/>}
                                        background={'#55a292'}
                                        label="Undelivered"
                                        items={kpis ? kpis.Send - kpis.Delivery : 0}
                                        percent={Math.floor(kpis.Delivery ? (kpis.Send - kpis.Delivery) * 100 / kpis.Send : 0)}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Open')}
                                        icon={<AiFillFolderOpen/>}
                                        background={'#71bfaf'}
                                        label="Opens"
                                        items={kpis ? kpis.Open : 0}
                                        percent={Math.floor(kpis.Open ? kpis.Open === 0 ? 0 : kpis.Open * 100 / kpis.Delivery : 0)}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Sale')}
                                        icon={<FiShoppingBag/>}
                                        background={'#71bfaf'}
                                        label="Sales"
                                        items={kpis.Sales ? kpis.Sales : 0}
                                        percent={Math.floor(kpis.Sales > 0 ? (kpis.Sales * 100 / kpis.Send) : 0)}
                                    />
                                </li>
                            </ul>

                            <ul className="list-inline list-unstyled">
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Click')}
                                        icon={<TbHandClick/>}
                                        background={'#55a292'}
                                        label="Clicks"
                                        items={kpis.Click ? kpis.Click : 0}
                                        percent={Math.floor(kpis.Click ? kpis.Click * 100 / kpis.Send : 0)}
                                        styles={{marginRight: '-10px'}}/>
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Unsubscribe')}
                                        icon={<FiTrash/>}
                                        background={'#b854ab'}
                                        label="Dropouts"
                                        items={kpis.Unsubscribe ? kpis.Unsubscribe : 0}
                                        percent={Math.floor(kpis.Unsubscribe ? kpis.Unsubscribe * 100 / kpis.Send : 0)}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Bounce')}
                                        icon={<TbRefreshAlert/>}
                                        background={'#b854ab'}
                                        label="Bounces"
                                        items={kpis.Bounce ? kpis.Bounce : 0}
                                        percent={Math.floor(kpis.Bounce ? kpis.Bounce * 100 / kpis.Send : 0)}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Complaint')}
                                        icon={<AlertTriangle/>}
                                        background={'#c147b1'}
                                        label="Spam"
                                        items={kpis.Complaint ? kpis.Complaint : 0}
                                        percent={Math.floor(kpis.Complaint ? kpis.Complaint * 100 / kpis.Send : 0)}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('NonSale')}
                                        icon={<FiArchive/>}
                                        background={'#c147b1'}
                                        label="Non Sales"
                                        items={kpis.NonSales ? kpis.NonSales : 0}
                                        percent={Math.floor(kpis.NonSales > 0 ? (kpis.NonSales * 100 / kpis.Send) : 0)}
                                    />
                                </li>
                            </ul>
                        </>}

                        {channel?.value === 'webservice' && <>
                            <ul className="list-inline list-unstyled">
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick(null)}
                                        label="Sent"
                                        icon={<FiSend/>}
                                        background={'#bdc2c4'}
                                        styles={{marginRight: '-10px'}}
                                        items={kpis ? kpis.Send : 0}
                                        percent={Math.floor(kpis.Send == 0 ? 0 : 100)}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('Sale')}
                                        icon={<FiShoppingBag/>}
                                        background={'#71bfaf'}
                                        label="Sales"
                                        items={kpis.Sales ? kpis.Sales : 0}
                                        percent={Math.floor(kpis.Sales > 0 ? (kpis.Sales * 100 / kpis.Send) : 0)}
                                    />
                                </li>
                                <li className="list-inline-item">
                                    <Item onClick={(ev) => handleStatusClick('NonSale')}
                                        icon={<FiArchive/>}
                                        background={'#c147b1'}
                                        label="Non Sales"
                                        items={kpis.NonSales ? kpis.NonSales : 0}
                                        percent={Math.floor(kpis.NonSales > 0 ? (kpis.NonSales * 100 / kpis.Send) : 0)}
                                    />
                                </li>
                            </ul>
                        </>}
                    </div>
                    <div className="card">
                        <ListingTable {...ListingOptions} />
                    </div>
                </>}
            </div>
        </div>

    );
};


export default Statistics;
